import "./index.scss";

import React from "react";
import { connect } from "react-redux";
import { setOpenedModal } from "../../redux/actions";
import LogoImg from "../../assets/images/logo_starting.svg";

const Starting = ({ openedModalStart }) => {
  return (
    <div className={`starting`}>
      <img
        src={LogoImg}
        className={`starting__logo ${
          openedModalStart && "starting__logo--hidden"
        }`}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  openedModalStart: state.openedModalStart,
});
const mapDispatchToProps = (dispatch) => ({
  setOpenedModal: (value) => dispatch(setOpenedModal(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Starting);
